import * as DOMUtils from "../frontendlib/dom_utils";

/*
 * ClickInteraction is used to connect elements that respond to clicks
 * with the elements that trigger click events. Primarily, this allows
 * dynamic CTAs to respond to click events on click overlays or any
 * other clickthrough element.
 */

// Global state for two-click CTAs.
let hasBeenClicked = false;
const firstClickHandlers = [];

// Global state for slider CTAs.
const SLIDER_COMPLETION_RATIO = 0.7;
const sliders = [];

const setSlideDistance = (value) => {
  sliders.forEach(({ sliderSize, setSlideRatio }) =>
    setSlideRatio(value / sliderSize)
  );
};

const getPointerEventX = (e) =>
  (
    (e.changedTouches && e.changedTouches[0]) ||
    (e.touches && e.touches[0]) ||
    e
  ).clientX;

class ClickInteraction {
  static captureFirstClick(handleFirstClick) {
    firstClickHandlers.push(handleFirstClick);
  }

  static captureSlideClick({ onCompleted, sliderSize, setSlideRatio }) {
    sliders.push({ onCompleted, sliderSize, setSlideRatio });
  }

  static addListeners(clickEl, onClickComplete) {
    clickEl.addEventListener(
      "click",
      (e) => {
        if (sliders.length > 0) {
          return;
        }

        if (!hasBeenClicked) {
          hasBeenClicked = true;

          if (firstClickHandlers.length > 0) {
            firstClickHandlers.forEach((handler) => handler(e));

            return;
          }
        }

        onClickComplete(e);
      },
      true
    );

    let slideStartPosition = null;
    DOMUtils.on(clickEl, {
      "mousedown touchstart": (e) => {
        slideStartPosition = getPointerEventX(e);
      },
      "mousemove touchmove": (e) => {
        if (slideStartPosition == null) return;

        setSlideDistance(getPointerEventX(e) - slideStartPosition);
      },
      "mouseup mouseleave touchend": (e) => {
        if (slideStartPosition == null) return;

        const slideDistance = getPointerEventX(e) - slideStartPosition;
        const completedSliders = sliders.filter(
          ({ sliderSize }) =>
            slideDistance > sliderSize * SLIDER_COMPLETION_RATIO
        );

        if (completedSliders.length > 0) {
          completedSliders.forEach(({ onCompleted }) => onCompleted());
          Promise.resolve(onClickComplete(e))
            .then(() => new Promise((resolve) => setTimeout(resolve, 1000)))
            .then(() => setSlideDistance(0));
        } else {
          setSlideDistance(0);
        }

        slideStartPosition = null;
      },
    });
  }
}

export default ClickInteraction;



// WEBPACK FOOTER //
// ./src/js/lib/click_interaction.js